import api from "services/api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils/utils";

export const DOCUMENTS_TRAFFIC_VIOLATION = API_URL_VERSION + "documentos-infracoes";
export const DOCUMENTS_TRAFFIC_VIOLATION_LIST = DOCUMENTS_TRAFFIC_VIOLATION + "/listar";

export const trafficViolationDocumentTypes = [
    { value: "AIT", label: "Auto de Infração de Trânsito" },
    { value: "ADVERTENCIA", label: "Requerimento de Advertência" },
    { value: "PAGAMENTO", label: "Confirmação de Pagamento" },
    { value: "RESSARCIMENTO", label: "Reembolso" },
];

export const documentsTrafficViolationsService = {
    create: async (data) => {
        try {
            const response = await api.post(`${DOCUMENTS_TRAFFIC_VIOLATION}`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.create";
        }
    },

    update: async (data, id) => {
        try {
            const response = await api.put(`${DOCUMENTS_TRAFFIC_VIOLATION}/${id}`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.update";
        }
    },

    list: async (params = {}, parentId) => {
        try {
            const response = await api.post(`${DOCUMENTS_TRAFFIC_VIOLATION_LIST}/${parentId}`, toSearchFilter(params));
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.list";
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${DOCUMENTS_TRAFFIC_VIOLATION}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.find";
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${DOCUMENTS_TRAFFIC_VIOLATION}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.delete";
        }
    },

};